import styled from 'styled-components';
import Colors from '../../../src/constants/colors';

export const Links = styled.a`
  color: ${Colors.primaryColor};
  text-decoration: underline;
  &:hover {
    color: ${Colors.hoverLinkColor};
  }
`;